var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as PIXI from "pixi.js";
import { registerPixiComponent } from "../ComponentRegistry.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import { A as AttachSchema } from "../../Attach-abbbd93e.js";
import { R as RadiusSchema } from "../../Radius-89a665f8.js";
import { G as GraphicSchema } from "../../Graphic-f0e31eeb.js";
import { hexToRgbNumber } from "../../utils/colors.js";
import { cloneDeep } from "lodash";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../enums-86f58524.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
import "../../utils/vector.js";
class GraphicPixiSystem {
  constructor() {
    __publicField(this, "ids", /* @__PURE__ */ new Set());
    __publicField(this, "schema", GraphicSchema);
    __publicField(this, "instances", {});
  }
  transform(pixiData, entity, data, gameModel, viewport) {
    const { graphic, container } = pixiData;
    graphic.pivot.set(data.anchorX * graphic.width, data.anchorY * graphic.height);
    if (data.rotation) {
      const angle = data.rotation * Math.PI / 180;
      graphic.rotation = angle;
    }
    if (container.scale.x !== data.scale) {
      container.scale.set(data.scale);
    }
    const verticalDistanceFromCenter = Math.abs(pixiData.container.y - viewport.center.y);
    const horizontalDistanceFromCenter = Math.abs(pixiData.container.x - viewport.center.x);
    if (horizontalDistanceFromCenter - pixiData.container.width / 2 > 1920 || verticalDistanceFromCenter - pixiData.container.height / 2 > 1080) {
      container.visible = false;
    } else {
      container.visible = true;
    }
  }
  drawGraphic(graphicData, graphics = new PIXI.Graphics()) {
    graphics.clear();
    if (graphicData.fillColor) {
      graphics.beginFill(hexToRgbNumber(graphicData.fillColor));
    }
    if (graphicData.strokeColor) {
      graphics.lineStyle(graphicData.lineWidth || 1, hexToRgbNumber(graphicData.strokeColor));
    }
    if (graphicData.circle) {
      graphics.drawCircle(graphicData.circle.x, graphicData.circle.y, graphicData.circle.radius);
    }
    if (graphicData.ellipse) {
      graphics.drawEllipse(
        graphicData.ellipse.x,
        graphicData.ellipse.y,
        graphicData.ellipse.width,
        graphicData.ellipse.height
      );
    }
    if (graphicData.rectangle) {
      graphics.drawRect(
        graphicData.rectangle.x,
        graphicData.rectangle.y,
        graphicData.rectangle.width,
        graphicData.rectangle.height
      );
    }
    if (graphicData.polygon) {
      graphics.drawPolygon(graphicData.polygon);
    }
    graphics.endFill();
    return graphics;
  }
  init(entity, gameModel, viewport) {
    var _a, _b;
    let zIndex = 2;
    const instance = {
      container: ((_a = this.instances[entity]) == null ? void 0 : _a.container) ?? new PIXI.Container(),
      debug: (_b = this.instances[entity]) == null ? void 0 : _b.debug
    };
    if (!instance.debug) {
      instance.debug = new PIXI.Container();
      instance.debug.visible = false;
      viewport.addChild(instance.debug);
    }
    const graphicData = gameModel.getTypedUnsafe(entity, GraphicSchema);
    instance.currentSchema = cloneDeep(graphicData);
    const graphics = this.drawGraphic(graphicData);
    instance.container.addChild(graphics);
    instance.graphic = graphics;
    instance.container.zIndex = zIndex;
    instance.graphic.position.set(0, 0);
    this.instances[entity] = instance;
    viewport.addChild(instance.container);
    this.ids.add(entity);
  }
  run(entity, gameModel, viewport) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    const graphicData = gameModel.getTypedUnsafe(entity, this.schema);
    if (!this.instances[entity]) {
      this.init(entity, gameModel, viewport);
    }
    let pixiData = this.instances[entity];
    let { graphic, container, debug, currentSchema } = pixiData;
    if (((_a = graphicData.circle) == null ? void 0 : _a.radius) !== ((_b = currentSchema.circle) == null ? void 0 : _b.radius) || ((_c = graphicData.circle) == null ? void 0 : _c.x) !== ((_d = currentSchema.circle) == null ? void 0 : _d.x) || ((_e = graphicData.circle) == null ? void 0 : _e.y) !== ((_f = currentSchema.circle) == null ? void 0 : _f.y) || ((_g = graphicData.ellipse) == null ? void 0 : _g.height) !== ((_h = currentSchema.ellipse) == null ? void 0 : _h.height) || ((_i = graphicData.ellipse) == null ? void 0 : _i.width) !== ((_j = currentSchema.ellipse) == null ? void 0 : _j.width) || ((_k = graphicData.ellipse) == null ? void 0 : _k.x) !== ((_l = currentSchema.ellipse) == null ? void 0 : _l.x) || ((_m = graphicData.ellipse) == null ? void 0 : _m.y) !== ((_n = currentSchema.ellipse) == null ? void 0 : _n.y) || ((_o = graphicData.rectangle) == null ? void 0 : _o.height) !== ((_p = currentSchema.rectangle) == null ? void 0 : _p.height) || ((_q = graphicData.rectangle) == null ? void 0 : _q.width) !== ((_r = currentSchema.rectangle) == null ? void 0 : _r.width) || ((_s = graphicData.rectangle) == null ? void 0 : _s.x) !== ((_t = currentSchema.rectangle) == null ? void 0 : _t.x) || ((_u = graphicData.rectangle) == null ? void 0 : _u.y) !== ((_v = currentSchema.rectangle) == null ? void 0 : _v.y) || ((_w = graphicData.polygon) == null ? void 0 : _w.length) !== ((_x = currentSchema.polygon) == null ? void 0 : _x.length) || !((_y = graphicData.polygon) == null ? void 0 : _y.every((v, i) => v === currentSchema.polygon[i]))) {
      this.drawGraphic(graphicData, graphic);
      pixiData.currentSchema = cloneDeep(graphicData);
      pixiData = this.instances[entity];
      ({ graphic, container, debug } = pixiData);
    }
    if (graphicData.opacity === 0) {
      graphic.visible = false;
    } else {
      graphic.visible = true;
      graphic.alpha = 1;
    }
    const transformSchema = gameModel.getTypedUnsafe(entity, TransformSchema);
    const position = transformSchema.position;
    position.y -= transformSchema.z;
    let xoffset = graphicData.xoffset ?? 0;
    let yoffset = graphicData.yoffset ?? 0;
    const viewY = viewport.position.y;
    if (graphicData.inheritParentZIndex && gameModel.hasComponent(entity, AttachSchema)) {
      const owner = gameModel.getComponentUnsafe(entity, AttachSchema).parent;
      container.zIndex = TransformSchema.store.y[owner] - viewY + TransformSchema.store.z[owner] + RadiusSchema.store.radius[owner] + graphicData.zIndex;
    } else if (graphicData.relativeZIndex) {
      container.zIndex = TransformSchema.store.y[entity] - viewY + TransformSchema.store.z[entity] + RadiusSchema.store.radius[entity] + graphicData.zIndex;
    }
    container.x = position.x + xoffset;
    container.y = position.y + yoffset;
    debug == null ? void 0 : debug.position.set(position.x, position.y);
    this.transform(pixiData, entity, graphicData, gameModel, viewport);
  }
  cleanup(entity, gameModel, viewport) {
    const instanceData = this.instances[entity];
    if (!instanceData) {
      return;
    }
    instanceData.container.destroy();
    const instance = this.instances[entity].graphic;
    instance.destroy();
    delete this.instances[entity];
    this.ids.delete(entity);
  }
}
registerPixiComponent("Graphic", GraphicPixiSystem);
export {
  GraphicPixiSystem
};
//# sourceMappingURL=Graphic.js.map
